import React, { useState } from "react";
import { Typography } from "@mui/material";
import { SaveTemplateModalStyled } from "./save-template-modal.styles";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-field";

const SaveTemplateModal = ({ show, onClose, onSave }) => {
  const [templateName, setTemplateName] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [globalError, setGlobalError] = useState("");

  const handleSave = () => {
    onSave(templateName, templateDescription); // Call parent-provided save handler
    onClose();
  };

  return (
    <SaveTemplateModalStyled
      confirmBtnTitle="Save"
      confirmBtnColor="#77E250"
      closeBtnTitle="Cancel"
      disableConfirmBtn={!templateName.trim() || !templateDescription.trim()}
      onConfirm={handleSave}
      onClose={onClose}
    >
      <div>
        <div className="head">
          <Typography variant="h4">Save as Template</Typography>
        </div>
        <div className="form">
          {globalError && <p className="error-text">{globalError}</p>}
          <div className="form-group">
          <TextInputField
            value={templateName}
            label={"Template Name*"}
            onChange={(e) => setTemplateName(e.target.value)}
            placeholder="Enter template name"
            sx={{ width: "100%" }}
          />
          </div>
          <div className="form-group">
            <TextInputField
              value={templateDescription}
              label={"Template Description*"}
              onChange={(e) => setTemplateDescription(e.target.value)}
              placeholder="Enter template description"
              sx={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </SaveTemplateModalStyled>
  );
};

export default SaveTemplateModal;
